document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('[data-resources-tab]');
  const panels = document.querySelectorAll('[data-resources-panel]');

  if (!tabs.length || !panels.length) return;

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      const target = tab.getAttribute('data-resources-tab');

      tabs.forEach(function (t) {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-resources-panel') !== target;
      });

      history.replaceState(null, '', target === 'citations' ? '#citations' : window.location.pathname);
    });
  });

  if (window.location.hash === '#citations') {
    const citationsTab = document.querySelector('[data-resources-tab="citations"]');
    if (citationsTab) citationsTab.click();
  }
});